export default __webpack_public_path__ + "static/O0090-931e56a480d1159a8af658b2d3cc04ff.png";